import React, { ReactNode } from 'react';
import GlobalError from './GlobalError';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    // Update state so the next render shows the fallback UI
    return { hasError: true };
  }

  // componentDidCatch(error: Error, errorInfo: ErrorInfo) {
  // Log error to the console or an error reporting service
  //     console.error('Error caught by ErrorBoundary:', error, errorInfo);
  // }

  render() {
    if (this.state.hasError) {
      return <GlobalError></GlobalError>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
